export default __webpack_public_path__ + "static/media/pyramide.a1f6925b.svg";